import { Link } from 'react-router-dom';

import { useLocale } from 'context/locale-context';

const DashboardButtonUpload = () => {
  const { getLocaleOption } = useLocale();

  return (
    <Link
      to='/my-diagnostic-findings'
      className='p-button p-component text-center text-2xl home-dashboard-button'
    >
      {getLocaleOption('uploadDocuments')}
    </Link>
  );
};

export default DashboardButtonUpload;
